import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline'
import { useId, useState } from 'react'

import { useCopy } from '../../i18n'
import { LINKS } from '../copy'

// Normales Akkordeon, die Section steht nicht still. Die erste Frage ist offen
export default function CandFaq() {
  const c = useCopy('faq')
  const [open, setOpen] = useState(0)
  const base = useId()

  return (
    <div className='ch-faq'>
      <h2 className='ch-faq__title'>{c.title}</h2>
      <div className='ch-faq__list'>
        {c.items.map((item, i) => {
          const isOpen = open === i
          const id = `${base}-${i}`
          return (
            <div key={item.q} className='ch-faq__item'>
              <h3>
                <button
                  type='button'
                  className='ch-faq__q'
                  aria-expanded={isOpen}
                  aria-controls={id}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                >
                  {item.q}
                  {isOpen ? (
                    <MinusIcon className='ch-faq__icon' />
                  ) : (
                    <PlusIcon className='ch-faq__icon' />
                  )}
                </button>
              </h3>
              <div
                id={id}
                role='region'
                className='ch-faq__a'
                data-open={isOpen}
                aria-hidden={!isOpen}
              >
                <div>
                  <p>{item.a}</p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
      <a
        className='ch-faq__privacy'
        href={LINKS.privacy}
        target='_blank'
        rel='noreferrer'
      >
        {c.privacy}
      </a>
    </div>
  )
}
